// client/api/services/teamService.ts
// Super-admin team management. Uses the shared apiClient (auth + refresh handled there).
import { apiClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export interface AdminAccount {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'super-admin';
  isActive: boolean;
  accountStatus?: string;
  lastLogin?: string;
  createdAt?: string;
}

export const listAdmins = async (): Promise<AdminAccount[]> => {
  const res = await apiClient.get<{ admins?: AdminAccount[] }>(ENDPOINTS.ADMIN.TEAM.ADMINS);
  return res.data.admins || [];
};

export const createAdmin = async (payload: {
  firstName: string; lastName: string; email: string; password: string;
}): Promise<unknown> => {
  const res = await apiClient.post<unknown>(ENDPOINTS.ADMIN.TEAM.ADMINS, payload);
  return res.data;
};

export const setAdminPassword = async (id: string, newPassword: string): Promise<unknown> => {
  const res = await apiClient.post<unknown>(ENDPOINTS.ADMIN.TEAM.SET_PASSWORD(id), { newPassword });
  return res.data;
};

export const setAdminActive = async (id: string, isActive: boolean): Promise<unknown> => {
  const res = await apiClient.patch<unknown>(ENDPOINTS.ADMIN.TEAM.SET_ACTIVE(id), { isActive });
  return res.data;
};
